// extracted by mini-css-extract-plugin
export default {"main":"main-page_main__o6PzM","main__content":"main-page_main__content__K4i38","title":"main-page_title__WOa14"};